import React from 'react'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash-es'

import { IconComponent } from '..'

import './CenteredModalContentComponent.scss'

const CenteredModalContentComponent = ({ icon, size, children }) => {
  const iconSize = size === 'small' ? [14, 14] : [24, 24]
  const iconElement = isUndefined(icon) ? null : (
    <div className="icon-container">
      <div className={`icon-wrapper icon-size-${size}`}>
        <IconComponent name={icon} size={iconSize} color="fff" />
      </div>
    </div>
  )

  return (
    <div className="centered-modal-content-component">
      {iconElement}
      {children}
    </div>
  )
}

CenteredModalContentComponent.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  size: PropTypes.oneOf(['small', 'normal']),
}

CenteredModalContentComponent.defaultProps = {
  size: 'normal',
}

export default CenteredModalContentComponent
